/* A shared, daily server snapshot; never expose provider tokens or private reviewer data. */
(() => {
  if (window.seifeHomepageReviewsStarted) return;
  window.seifeHomepageReviewsStarted = true;
  const root = window.Shopify?.routes?.root || "/";
  const locale = document.documentElement.lang.split("-")[0];
  const copy = ({
    de: { selected: "Ausgewählte Kundenbewertungen", more: "Weitere Bewertungen laden", details: "Details", options: "Optionen wählen", add: "Ins Chörbli", verified: "Verifizierter Kauf" },
    en: { selected: "Selected customer reviews", more: "Load more reviews", details: "Details", options: "Choose options", add: "Add to basket", verified: "Verified purchase" },
    fr: { selected: "Avis clients sélectionnés", more: "Afficher plus d’avis", details: "Détails", options: "Choisir les options", add: "Ajouter au panier", verified: "Achat vérifié" },
    ar: { selected: "آراء مختارة للعملاء", more: "عرض المزيد من الآراء", details: "التفاصيل", options: "اختيار الخيارات", add: "أضف إلى السلة", verified: "عملية شراء موثّقة" }
  })[locale] || { selected: "Selected customer reviews", more: "Load more reviews", details: "Details", options: "Choose options", add: "Add to basket", verified: "Verified purchase" };
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
  const link = (path, label, cls) => { const n = el("a", cls, label); n.href = `${root.replace(/\/$/, "")}${path}`; return n; };
  const stars = r => "★".repeat(r.rating) + "☆".repeat(5 - r.rating);
  const date = r => new Date(r.date).toLocaleDateString(locale);
  function card(r) {
    const n = el("article", "review-card");
    const header = el("div", "review-card__header");
    header.append(el("div", "review-card__stars", stars(r)));
    const time = el("time", "review-card__date", `JUDGE.ME · ${date(r)}`); time.dateTime = r.date; header.append(time);
    n.append(header, el("div", "review-card__title", r.title), el("div", "review-card__body", r.body));
    const meta = el("div", "review-card__meta"); meta.append(el("span", "review-card__author", r.author));
    if (r.verified) meta.append(el("span", "review-card__verified", `✓ ${copy.verified}`));
    if (r.productPath) meta.append(link(r.productPath, r.productTitle, "review-card__product"));
    n.append(meta); return n;
  }
  async function slide(r) {
    const n = el("article", "review-commerce__slide"); n.dataset.reviewSlide = ""; n.hidden = true;
    n.append(el("div", "review-commerce__stars", stars(r)), el("blockquote", "", `„${r.body}“`));
    const meta = el("p", "review-commerce__meta"); meta.append(el("strong", "", r.author));
    if (r.verified) meta.append(el("span", "review-commerce__verified", `✓ ${copy.verified}`));
    const time = el("time", "", `JUDGE.ME · ${date(r)}`); time.dateTime = r.date; meta.append(time); n.append(meta);
    if (!r.productPath) return n;
    const productCard = el("div", "review-commerce__product");
    const details = el("div", "review-commerce__details"); details.append(link(r.productPath, r.productTitle)); productCard.append(details);
    try {
      const response = await fetch(`${root.replace(/\/$/, "")}${r.productPath}.js`, { signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error("Product unavailable");
      const p = await response.json(), v = p.variants.find(v => v.available);
      if (p.featured_image) { const image = el("img"); image.src = p.featured_image; image.alt = p.title; image.width = 90; image.height = 90; image.loading = "lazy"; productCard.prepend(image); }
      if (v) details.append(el("bdi", "review-commerce__price", new Intl.NumberFormat(locale, { style: "currency", currency: window.Shopify?.currency?.active || "CHF" }).format(v.price / 100)));
      if (v && p.variants.length === 1) {
        const form = el("form", "review-commerce__form"); form.method = "post"; form.action = `${root}cart/add`; form.dataset.productForm = ""; form.dataset.reviewProduct = "";
        const id = el("input"); id.type = "hidden"; id.name = "id"; id.value = v.id;
        const qty = el("input"); qty.type = "hidden"; qty.name = "quantity"; qty.value = "1";
        const button = el("button", "", copy.add); button.type = "submit";
        form.append(id, qty, button); productCard.append(form);
      } else productCard.append(link(r.productPath, copy.options, "button"));
    } catch { productCard.append(link(r.productPath, copy.details, "button")); }
    n.append(productCard); return n;
  }
  async function load() {
    let data;
    try {
      const response = await fetch(`${root.replace(/\/$/, "")}/apps/seifeops/storefront/homepage-reviews`, { signal: AbortSignal.timeout(8000) });
      if (!response.ok) throw new Error("Snapshot unavailable");
      data = await response.json();
    } catch {
      console.warn("Daily review service unavailable; using the last published review snapshot.");
      const url = document.querySelector("[data-homepage-reviews]")?.dataset.snapshotUrl;
      if (!url) throw new Error("No published snapshot");
      const response = await fetch(url);
      if (!response.ok) throw new Error("Published snapshot unavailable");
      data = await response.json();
    }
    if (!Array.isArray(data.reviews)) throw new Error("Invalid snapshot");
    const reviews = data.reviews.filter(r => r.rating >= 4 && r.rating <= 5 && r.body);
    // Shuffle once per page load; progressive batches retain this order.
    for (let i = reviews.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [reviews[i], reviews[j]] = [reviews[j], reviews[i]]; }
    document.documentElement.dataset.reviewsSyncedAt = data.syncedAt;
    const grid = document.querySelector(".home-reviews__grid"), rotator = document.querySelector("[data-review-rotator]");
    if (grid) {
      grid.replaceChildren();
      let count = 0;
      const more = el("button", "button button--secondary", copy.more); more.type = "button"; more.style.marginBlock = "2rem";
      const showMore = () => { grid.append(...reviews.slice(count, count + 9).map(card)); count += 9; more.hidden = count >= reviews.length; };
      const section = grid.closest("section"); section.querySelector("h2").textContent = copy.selected;
      grid.after(more); more.addEventListener("click", showMore); showMore();
      if (!reviews.length) section.hidden = true;
    }
    if (rotator) {
      if (!reviews.length) { rotator.hidden = true; return; }
      const shuffled = [...reviews];
      for (let i = shuffled.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; }
      const slides = await Promise.all(shuffled.slice(0, 5).map(slide));
      slides[0].hidden = false; slides[0].classList.add("is-active");
      rotator.querySelector(".review-commerce__slides").replaceChildren(...slides);
      rotator.querySelector(".eyebrow").textContent = copy.selected;
      const provenance = rotator.querySelector(".visually-hidden"); if (provenance) provenance.textContent = `Judge.me · ${new Date(data.syncedAt).toLocaleDateString(locale)}`;
      rotator.dispatchEvent(new Event("seife:reviews-loaded"));
    }
  }
  load().catch(() => console.warn("Live homepage review snapshot unavailable; existing reviews retained."));
})();
